const services = [
  {
    icon: 'ri-home-4-line',
    title: 'Nettoyage Résidentiel',
    description: 'Entretien régulier ou ponctuel de votre appartement ou villa à Genève. Nettoyage complet de toutes les pièces, cuisine, salles de bain, sols et vitres.',
    features: ['Nettoyage hebdomadaire ou bimensuel', 'Grand nettoyage de printemps', 'Nettoyage avant/après déménagement', 'Nettoyage de fin de bail', 'Vitres et surfaces vitrées', 'Désinfection complète'],
    image: 'https://readdy.ai/api/search-image?query=spotless%20modern%20luxury%20apartment%20interior%20Geneva%20Switzerland%20clean%20bright%20living%20room%20polished%20hardwood%20floors%20gleaming%20surfaces%20professional%20residential%20cleaning%20result%20minimalist%20warm%20decor%20natural%20light&width=700&height=460&seq=nettoyage-residentiel-v2-01&orientation=landscape',
    tag: 'Particuliers',
    tagColor: 'bg-emerald-100 text-emerald-700',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Nettoyage de Bureaux & Commerces',
    description: 'Maintien d\'un environnement de travail sain et professionnel. Interventions en dehors des heures de bureau pour ne pas perturber votre activité.',
    features: ['Nettoyage quotidien ou hebdomadaire', 'Sanitaires et espaces communs', 'Sols, moquettes et parquets', 'Postes de travail et surfaces', 'Cuisine et espaces de pause', 'Gestion des déchets'],
    image: 'https://readdy.ai/api/search-image?query=clean%20modern%20office%20space%20Geneva%20Switzerland%20spotless%20open%20plan%20workspace%20polished%20floors%20tidy%20desks%20bright%20professional%20environment%20commercial%20cleaning%20result%20contemporary%20interior%20warm%20light&width=700&height=460&seq=nettoyage-bureau-v2-01&orientation=landscape',
    tag: 'Entreprises',
    tagColor: 'bg-stone-100 text-stone-700',
  },
  {
    icon: 'ri-community-line',
    title: 'Conciergerie d\'Immeubles',
    description: 'Gestion complète de l\'entretien de vos parties communes, caves, parkings et espaces extérieurs. Service de conciergerie professionnel pour régies et copropriétés.',
    features: ['Nettoyage des parties communes', 'Entretien des espaces verts', 'Gestion des poubelles et tri', 'Surveillance et petits travaux', 'Signalement des anomalies', 'Rapport mensuel d\'activité'],
    image: 'https://readdy.ai/api/search-image?query=clean%20modern%20apartment%20building%20entrance%20hall%20Geneva%20Switzerland%20polished%20marble%20floors%20spotless%20lobby%20elevator%20area%20bright%20lighting%20professional%20concierge%20service%20pristine%20common%20areas%20warm&width=700&height=460&seq=conciergerie-v2-01&orientation=landscape',
    tag: 'Immeubles',
    tagColor: 'bg-amber-100 text-amber-700',
  },
  {
    icon: 'ri-sparkling-2-line',
    title: 'Nettoyage Spécialisé',
    description: 'Interventions spécifiques pour des besoins particuliers : après travaux, nettoyage industriel, remise en état après sinistre ou nettoyage de chantier.',
    features: ['Nettoyage après travaux/chantier', 'Remise en état après sinistre', 'Nettoyage de vitres en hauteur', 'Traitement des sols (cristallisation)', 'Désinfection et assainissement', 'Nettoyage de façades'],
    image: 'https://readdy.ai/api/search-image?query=professional%20specialized%20cleaning%20service%20after%20construction%20renovation%20Geneva%20Switzerland%20workers%20in%20white%20uniform%20cleaning%20dust%20debris%20post-construction%20cleanup%20bright%20clean%20result%20professional%20equipment%20warm%20light&width=700&height=460&seq=nettoyage-specialise-v2-01&orientation=landscape',
    tag: 'Spécialisé',
    tagColor: 'bg-rose-100 text-rose-700',
  },
];

export default function NettoyageServices() {
  return (
    <section id="services-nettoyage" className="py-24 bg-stone-50">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-emerald-50 border border-emerald-200 rounded-full px-4 py-1.5 mb-5">
            <i className="ri-brush-line text-emerald-600 text-sm"></i>
            <span className="text-xs font-bold tracking-widest uppercase text-emerald-600">Nos Prestations</span>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Services de Nettoyage &amp; Conciergerie</h2>
          <p className="text-base text-gray-500 max-w-2xl mx-auto leading-relaxed">
            Des solutions adaptées à chaque besoin, pour les particuliers, les entreprises et les gestionnaires d'immeubles à Genève.
          </p>
        </div>

        {/* Services alternés */}
        <div className="space-y-16">
          {services.map((service, index) => (
            <div
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-10 items-center bg-white rounded-2xl overflow-hidden border border-stone-100`}
            >
              {/* Image */}
              <div className="w-full lg:w-1/2 h-[280px] md:h-[340px] overflow-hidden shrink-0">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Content */}
              <div className="w-full lg:w-1/2 p-8 lg:p-10">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-11 h-11 flex items-center justify-center bg-emerald-500 rounded-xl">
                    <i className={`${service.icon} text-xl text-white`}></i>
                  </div>
                  <span className={`text-xs font-semibold px-3 py-1 rounded-full ${service.tagColor}`}>{service.tag}</span>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-500 leading-relaxed mb-6 text-sm">{service.description}</p>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-7">
                  {service.features.map((feat, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <i className="ri-check-line text-emerald-500 mt-0.5 shrink-0 text-sm"></i>
                      <span className="text-sm text-gray-600">{feat}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="#contact-nettoyage"
                  className="inline-flex items-center gap-2 rounded-lg bg-gray-900 px-6 py-3 text-sm font-semibold text-white hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Demander un devis
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
